"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import ContactButton from '../../components/shared/ContactButton';

export function HomeBanner() {
  return (
    <section 
      
      className="px-[5%] py-16 md:py-24 lg:py-28 max-h-[900px] bg-[rgba(0,0,0,0.5)] h-dvh w-dvw"
    >
      <div className="container flex items-center  md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="flex flex-col gap-5 md:flex-col md:gap-5 lg:gap-5 md:backdrop-blur-[2px] md:py-40 md:pl-40 md:-ml-40 text-white  text-shadow-[2px_2px_4px_rgba(0,0,0,0.5)]">
          <div className="w-full max-w-lg">
            <h1 className="mb-5 text-4xl leading-[1.2] md:mb-6 md:text-[50px] lg:text-[50px] max-w-[500px] font-bold">
            Umfassende Cyber-Sicherheitslösungen für Ihr Unternehmen            </h1>
          </div>
          <div className="w-full max-w-lg">
            <p className="md:text-md">
            Schützen Sie Ihr Unternehmen mit unseren maßgeschneiderten Cybersicherheitslösungen. Von Risikoanalysen bis hin zu kontinuierlichem Monitoring bieten wir umfassende Sicherheitsstrategien.            </p>
            <div className="mt-6 flex flex-wrap gap-4 md:mt-8">
              <ContactButton/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
